const fonts = ["Inter", "Roboto", "Helvetica Neue", "Arial", "sans-serif"];

export default fonts;
